import React, { useState, useRef } from "react";
import { FormControl, Menu, MenuItem, Popover } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckIcon from "@mui/icons-material/Check";
import {
  isPresetOffset,
  offsetKey,
  offsetLabel,
  sameOffset,
  TRIGGER_PRESETS,
} from "./emailSettingsDisplay";

const UNIT_OPTIONS = [
  { value: "minutes", label: "Minutes" },
  { value: "hours", label: "Hours" },
  { value: "days", label: "Days" },
];

const menuPaper = (anchor) => ({
  className: "email-repeat-menu",
  sx: { width: anchor?.clientWidth, maxWidth: "100%" },
});

const CustomTimePanel = ({ draft, onChange }) => (
  <div className="email-repeat-custom">
    <div className="email-repeat-custom__head">
      <p>Time Before Event</p>
      <input
        type="number"
        min="1"
        value={draft.value}
        onChange={(e) =>
          onChange({
            value: Number(e.target.value) || 1,
            unit: draft.unit || "days",
          })
        }
      />
    </div>
    <div className="email-repeat-custom__units">
      {UNIT_OPTIONS.map((item) => (
        <button
          key={item.value}
          type="button"
          className={`email-repeat-custom__unit${
            draft.unit === item.value ? " is-selected" : ""
          }`}
          onClick={() => onChange({ ...draft, unit: item.value })}
        >
          <span className="email-repeat-custom__radio" />
          {item.label}
        </button>
      ))}
    </div>
  </div>
);

export const TriggerTimingField = ({
  value,
  onChange,
  disabled,
  presets = TRIGGER_PRESETS,
}) => {
  const fieldRef = useRef(null);
  const [menu, setMenu] = useState(null);
  const isCustom = value && !isPresetOffset(value, presets);
  const [customDraft, setCustomDraft] = useState(
    isCustom ? value : { value: 1, unit: "days" }
  );
  const customOpen = menu === "custom";
  const presetOpen = menu === "preset";

  const applyCustom = (next) => {
    const draft = {
      value: Number(next.value) || 1,
      unit: next.unit || "days",
    };
    setCustomDraft(draft);
    onChange(draft);
  };

  return (
    <FormControl
      fullWidth
      className={`email-trigger-field${disabled ? " is-disabled" : ""}`}
    >
      <button
        ref={fieldRef}
        type="button"
        className={`email-repeat-field email-repeat-field--single${
          menu ? " is-open" : ""
        }`}
        onClick={() => !disabled && setMenu("preset")}
        disabled={disabled}
      >
        <span>
          {customOpen
            ? "Custom Time"
            : offsetLabel(value, { eventSuffix: true })}
        </span>
        <KeyboardArrowDownIcon
          fontSize="small"
          className="email-repeat-field__caret"
        />
      </button>
      <Menu
        anchorEl={fieldRef.current}
        open={presetOpen}
        onClose={() =>
          setMenu((current) => (current === "preset" ? null : current))
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={menuPaper(fieldRef.current)}
      >
        {presets.map((item) => (
          <MenuItem
            key={offsetKey(item)}
            selected={sameOffset(item, value)}
            onClick={() => {
              onChange(item);
              setMenu(null);
            }}
          >
            {offsetLabel(item, { eventSuffix: true })}
            {sameOffset(item, value) ? <CheckIcon fontSize="small" /> : null}
          </MenuItem>
        ))}
        <MenuItem
          selected={Boolean(isCustom)}
          onClick={() => {
            const draft = isCustom ? value : { value: 1, unit: "days" };
            setCustomDraft(draft);
            if (!isCustom) onChange(draft);
            setMenu("custom");
          }}
        >
          Custom Time
        </MenuItem>
      </Menu>
      <Popover
        anchorEl={fieldRef.current}
        open={customOpen}
        onClose={() =>
          setMenu((current) => (current === "custom" ? null : current))
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          className: "email-repeat-menu email-repeat-menu--custom",
          sx: { width: fieldRef.current?.clientWidth, maxWidth: "100%" },
        }}
      >
        <CustomTimePanel draft={customDraft} onChange={applyCustom} />
      </Popover>
    </FormControl>
  );
};
